<template>
  <div>
    <v-app-bar flat color="transparent" class="main-appbar">
      <app-bar-nav-icon />
      <v-skeleton-loader
        type="chip"
        transition="fade-transition"
        v-if="initialLoadingPage"
      ></v-skeleton-loader>

      <v-toolbar-title v-else class="headline font-weight-bold">
        Bookings ({{ listMeta.total }})
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-row align="center" style="max-width: 300px">
        <v-text-field
          v-if="!initialLoadingPage"
          class="search"
          ref="searchField"
          flat
          hide-details
          solo
          rounded
          clearable
          background-color="grey lighten-3"
          label="Search tool, owner, code, amount"
          v-model="filter.search"
          @input="search"
        ></v-text-field>
      </v-row>

      <v-skeleton-loader
        type="actions"
        transition="fade-transition"
        v-if="initialLoadingPage"
      ></v-skeleton-loader>

      <template v-else>
        <v-btn class="ml-5" icon @click="showSearchField">
          <img src="@/assets/icons/search.svg" alt height="17.7px" />
        </v-btn>
      </template>
    </v-app-bar>

    <div class="mt-2 mx-4" id="user-list">
      <v-simple-table>
        <thead v-show="!initialLoadingPage">
          <tr>
            <th
              width="5%"
              class="text-left pa-0"
              @click="sortColumn"
              data-column="booking_code"
            >
              Code
              <v-icon v-if="params.sort_by == `booking_code`">{{
                icons.selectedArrow
              }}</v-icon>
            </th>
            <th
              width="10%"
              class="text-left pa-0"
              @click="sortColumn"
              data-column="name"
            >
              Tool Name
              <v-icon v-if="params.sort_by == `tool_name`">{{
                icons.selectedArrow
              }}</v-icon>
            </th>
            <th
              width="15%"
              class="text-left pa-0"
              @click="sortColumn"
              data-column="tool_owner"
            >
              Tool Owner
              <v-icon v-if="params.sort_by == `tool_owner`">{{
                icons.selectedArrow
              }}</v-icon>
            </th>
            <th
              width="15%"
              class="text-left pa-0"
              @click="sortColumn"
              data-column="renter"
            >
              Renter
              <v-icon v-if="params.sort_by == `renter`">{{
                icons.selectedArrow
              }}</v-icon>
            </th>
            <th
              width="10%"
              class="text-left pa-0"
              @click="sortColumn"
              data-column="grand_total"
            >
              Grand Total
              <v-icon v-if="params.sort_by == `grand_total`">{{
                icons.selectedArrow
              }}</v-icon>
            </th>
            <th
              width="10%"
              class="text-left pa-0"
              @click="sortColumn"
              data-column="booked_from"
            >
              Booked From
              <v-icon v-if="params.sort_by == `booked_from`">{{
                icons.selectedArrow
              }}</v-icon>
            </th>
            <th
              width="10%"
              class="text-left pa-0"
              @click="sortColumn"
              data-column="booked_to"
            >
              Booked To
              <v-icon v-if="params.sort_by == `booked_to`">{{
                icons.selectedArrow
              }}</v-icon>
            </th>
            <th
              width="10%"
              class="text-left"
              @click="sortColumn"
              data-column="created_at"
            >
              Added date
              <v-icon v-if="params.sort_by == `created_at`">{{
                icons.selectedArrow
              }}</v-icon>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-show="!loading" v-for="booking in bookings" :key="booking.id">
            <td class="p-0">
              <router-link
                :to="{
                  name: 'bookings.details',
                  params: { code: booking.booking_code },
                }"
                >{{ booking.booking_code }}</router-link
              >
            </td>
            <td>
              <router-link
                :to="{
                  name: 'tools.details',
                  params: { id: booking.tool.id },
                }"
                >{{ booking.tool.name }}</router-link
              >
            </td>
            <td>
              <router-link
                :to="{
                  name: 'user.details',
                  params: { id: booking.tool_owner.id },
                }"
                >{{ booking.tool_owner.full_name }}</router-link
              >
            </td>
            <td>
              <router-link
                :to="{
                  name: 'user.details',
                  params: { id: booking.renter.id },
                }"
                >{{ booking.renter.full_name }}</router-link
              >
            </td>
            <td>
              <strong>{{ booking.total.grand_total }}</strong>
              {{ booking.total.currency }}
            </td>
            <td>{{ booking.bookedFrom }}</td>
            <td>{{ booking.bookedTo }}</td>
            <td>{{ booking.addedDate }}</td>
          </tr>

          <template v-if="initialLoadingPage || loading">
            <tr v-for="index in params.limit" :key="index + '-skeleton'">
              <td class="py-3 pl-0" width="5%">
                <v-skeleton-loader
                  class="avatar-loading--36"
                  type="avatar"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
              <td class="pl-0">
                <v-skeleton-loader
                  type="list-item"
                  transition="fade-transition"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>

      <br />
      <v-card
        v-if="!initialLoadingPage"
        class="d-flex justify-end mb-6"
        flat
        tile
        no-gutters
      >
        <v-select
          dense
          solo
          class="pagination-limit"
          :items="limits"
          label="Items per page"
          v-model="params.limit"
          @change="onSelectItem"
        ></v-select>

        <v-pagination
          v-model="page"
          :length="listMeta.last_page"
          :total-visible="10"
        ></v-pagination>
      </v-card>
      <v-skeleton-loader
        type="list-item"
        transition="fade-transition"
        v-if="initialLoadingPage"
      ></v-skeleton-loader>
    </div>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" right>
      {{ snackbar.message }}
      <v-btn color="white" text @click="snackbar.show = false">Ok</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import {
  mdiDotsVertical,
  mdiUnfoldMoreHorizontal,
  mdiMagnify,
  mdiAccountCircleOutline,
  mdiChevronRight,
  mdiFileExcel,
  mdiArrowUpBold,
  mdiArrowDownBold,
} from '@mdi/js'
import ControlsMixin from '@/utils/mixins/Controls'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import infiniteScroll from 'vue-infinite-scroll'
import debounce from 'lodash/debounce'

export default {
  name: 'BookingsPage',

  mixins: [ControlsMixin],

  directives: {
    infiniteScroll,
  },

  components: {
    AppBarNavIcon,
  },

  data() {
    return {
      loading: false,
      initialLoadingPage: true,
      isLoadingPagination: false,
      showSearch: false,
      showProfile: false,
      selectedProfile: null,
      filter: {
        search: '',
      },
      icons: {
        settings: mdiDotsVertical,
        sort: mdiUnfoldMoreHorizontal,
        search: mdiMagnify,
        view: mdiAccountCircleOutline,
        arrow: mdiChevronRight,
        export: mdiFileExcel,
        arrowUp: mdiArrowUpBold,
        arrowDown: mdiArrowDownBold,
        selectedArrow: mdiArrowUpBold,
      },
      snackbar: {
        show: false,
        message: null,
        color: null,
      },
      params: {
        sort_direction: 'asc',
        sort_by: null,
        limit: 10,
      },
      page: 1,
      limits: [5, 10, 20, 30, 50],
    }
  },

  created() {
    this.clearBookings()
    this.fetchBookings()
  },

  computed: {
    ...mapState({
      bookings: (state) => state.booking.list,
      listMeta: (state) => state.booking.listMeta,
    }),

    paginationLength() {
      return (this.listMeta.total / this.listMeta.per_page) | 0
    },
  },

  methods: {
    ...mapActions({
      getBookings: 'booking/getBookings',
    }),

    ...mapMutations({
      clearBookings: 'booking/clearBookingList',
    }),

    pageChanged(page) {
      this.fetchBookings(page)
    },
    onSelectItem() {
      this.clearBookings()
      this.fetchBookings(1)
    },
    loadMore() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        this.fetchBookings(this.listMeta.current_page + 1)
      }
    },
    sortColumn(e) {
      this.params.sort_direction =
        this.params.sort_direction === 'asc' ? 'desc' : 'asc'

      this.icons.selectedArrow =
        this.params.sort_direction === 'asc' ? mdiArrowUpBold : mdiArrowDownBold

      this.clearBookings()
      this.params.sort_by = e.target.getAttribute('data-column')
      this.fetchBookings()
    },

    search: debounce(function () {
      this.clearBookings()
      this.fetchBookings()
    }, 600),

    async fetchBookings(page = 1) {
      if (this.loading) return

      let params = this.params
      params.page = page

      if (this.filter.search) {
        params.search = this.filter.search
      } else {
        params.search = ''
      }

      if (!this.initialLoadingPage) {
        this.loading = true
      } else {
        this.isLoadingPagination = true
      }

      await this.getBookings(params)

      if (!this.initialLoadingPage) {
        this.loading = false
      } else {
        this.isLoadingPagination = false
      }

      this.initialLoadingPage = false
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.color = color
      this.snackbar.show = true
    },

    async showSearchField() {
      this.showSearch = !this.showSearch
      await this.$nextTick()
      this.$refs.searchField.$refs.input.focus()
    },
  },
  watch: {
    page() {
      this.pageChanged(this.page)
    },
  },
}
</script>
